import type { ExtendedSubFlow } from '@withdrawals/types'
import { WithdrawalSubFlows } from 'mmfintech-backend-api'

type RouteData = {
  subFlow: ExtendedSubFlow
  pathname: string
}

export const FLOW_ROUTES: RouteData[] = [
  {
    subFlow: WithdrawalSubFlows.BANKWIRE,
    pathname: 'bank-transfer'
  },
  // REMITTANCE
  {
    subFlow: WithdrawalSubFlows.CRYPTO,
    pathname: 'crypto'
  },
  {
    subFlow: WithdrawalSubFlows.INTERNAL_TRANSFER,
    pathname: 'transfer'
  },
  {
    subFlow: WithdrawalSubFlows.JETON_WALLET,
    pathname: 'jeton-wallet'
  },
  // JETON_BANK_WALLET
  // KINGDOM_WALLET
  // BATCH
  {
    subFlow: WithdrawalSubFlows.INTRA_ACCOUNT_TRANSFER,
    pathname: 'own-accounts'
  },
  {
    subFlow: WithdrawalSubFlows.PIX,
    pathname: 'pix'
  },
  {
    subFlow: WithdrawalSubFlows.INTERAC,
    pathname: 'interac'
  },
  {
    subFlow: WithdrawalSubFlows.PERFECT_MONEY,
    pathname: 'perfect-money'
  },
  // CASH
  {
    subFlow: WithdrawalSubFlows.SKRILL,
    pathname: 'skrill'
  },
  // ZIMPLER
  // SKRILL_1_TAP
  {
    subFlow: WithdrawalSubFlows.PAY_TO_CARD,
    pathname: 'card'
  },
  // PAY_TO_MOBILE
  // TRUSTLY
  {
    subFlow: WithdrawalSubFlows.MASTERCARD,
    pathname: 'mastercard'
  },
  {
    subFlow: 'SUB_ACCOUNTS',
    pathname: 'linked-accounts'
  }
] as const
